// extracted by mini-css-extract-plugin
module.exports = {"header":"BlogHeader-module--header--3_rTF","content":"BlogHeader-module--content--3pvTL","original":"BlogHeader-module--original--1E8ii"};